@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.container {
  display: flex;
  flex-direction: column;
  padding: 0 15px 10px;
}

.purchase-warning {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.purchase-input {
  width: 130px;
  padding-left: 10px;
}

.notification {
  padding: 5px 0;
  overflow: hidden;
}

.notification-error {
  color: @cost-review-item--purchase--text-color;
  font-size: 12px;
  line-height: 1.3;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  max-width: 670px;
}

.error-icon {
  height: 30px;
  width: 30px;
  margin-right: 5px;
}

.error-text {
  width: 100%;
  margin: 5px 0;
  align-self: center;
  padding-left: 6px;
  &.requires-phone-verification {
    margin-right: 35px;
  }
}

.warning-text {
  width: 100%;
  margin: 5px 0;
  align-self: center;
  font-weight: @bold;
  color: @cost-review-item--purchase--warning--text-color;
}

.error-and-input {
  display: flex;
}

.min-purchase-message {
  font-size: 12px;
  color: @cost-review-item--purchase-message--text-color;
  text-align: right;
  margin-top: 5px;
  font-weight: @bold;
}

.provider-error-message {
  margin-top: 10px;
}

.warning {
  color: @cost-review-item--purchase--text-color;
  text-align: left;
  font-size: 13px;
  line-height: 1.3;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
